import "./Pagination.scss";
import ReactPaginate from "react-paginate";
import { useSearchParams } from "react-router-dom";
import SelectField from "../../primaryComponents/SelectField/SelectField";

const Pagination = ({
  handlePageClick,
  totalPageNumber = 1,
  currentPage = 1,
  pageRangeDisplayed = 3,
  perPage,
  onPerPageChange,
  perPageOptions = [10, 20, 30, 50],
  showPerPage = true,
}) => {
  const [search, setSearch] = useSearchParams();

  if (!totalPageNumber || totalPageNumber <= 0) {
    return null;
  }

  const currentPerPage = perPage || Number(search.get("per_page")) || 20;

  const handleSelectOption = (optionValue) => {
    if (onPerPageChange) {
      onPerPageChange(optionValue);
    } else {
      search.set("per_page", optionValue);
      search.delete("page");
      setSearch(search, { replace: true });
    }
  };

  const paginateComponent = (
    <ReactPaginate
      breakLabel="..."
      nextLabel="Next >"
      onPageChange={(value) => {
        if (currentPage === value?.selected + 1) return;
        handlePageClick(value);
      }}
      pageRangeDisplayed={pageRangeDisplayed}
      pageCount={totalPageNumber}
      previousLabel="< Prev"
      initialPage={currentPage - 1}
      renderOnZeroPageCount={null}
      containerClassName="pagination-conatiner"
      previousLinkClassName="previous-Bttn"
      nextLinkClassName="next-Bttn"
      disabledClassName="pagination-btn-disabled"
      activeClassName="pagination-active"
    />
  );

  if (!showPerPage) {
    return paginateComponent;
  }

  return (
    <div className="pagination-wrapper">
      <div className="pagination-per-page">
        <SelectField
          sideLabel="Show:"
          value={`${currentPerPage}`}
          options={perPageOptions.map((opt) => ({
            id: opt,
            name: `${opt}`,
          }))}
          idKey="id"
          nameKey="name"
          onChange={(value) => handleSelectOption(value)}
          minHeight="25px"
          classNames="pagination-select"
        />
      </div>

      <div className="pagination-wrapper__controls">{paginateComponent}</div>
    </div>
  );
};

export default Pagination;
